import { render, staticRenderFns } from "./nuxt-error.vue?vue&type=template&id=74e3df5b&"
import script from "./nuxt-error.vue?vue&type=script&lang=js&"
export * from "./nuxt-error.vue?vue&type=script&lang=js&"
import style0 from "./nuxt-error.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kusanagi/adop-line-ec_tamano/ec/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74e3df5b')) {
      api.createRecord('74e3df5b', component.options)
    } else {
      api.reload('74e3df5b', component.options)
    }
    module.hot.accept("./nuxt-error.vue?vue&type=template&id=74e3df5b&", function () {
      api.rerender('74e3df5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = ".nuxt/components/nuxt-error.vue"
export default component.exports